(function () {
  var MOBILE_BREAKPOINT = 750;
  var DEFAULT_ROOT_MARGIN = '80px';
  var DEFAULT_THRESHOLD = 0.05;

  /**
   * Load Swiper once. Reuses main.js loader when available to avoid conflict and double-load.
   * If main.js already loaded Swiper or is loading it, we wait for that.
   */
  function loadSwiperScript() {
    if (typeof window.Swiper === 'function') return Promise.resolve();
    var existing = window.__fuzionSwiperLoadPromise;
    if (existing) return existing;
    var url = window.swiperBundleUrl || '/assets/swiper-bundle.min.js';
    var existingScript = document.querySelector('script[src*="swiper-bundle"]');
    if (existingScript) {
      window.__fuzionSwiperLoadPromise = new Promise(function (resolve) {
        var attempts = 0;
        var interval = setInterval(function () {
          if (typeof window.Swiper === 'function' || ++attempts >= 200) {
            clearInterval(interval);
            resolve();
          }
        }, 50);
      });
      return window.__fuzionSwiperLoadPromise;
    }
    window.__fuzionSwiperLoadPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.defer = true;
      script.onload = resolve;
      script.onerror = function () { reject(new Error('Swiper load failed')); };
      document.body.appendChild(script);
    });
    return window.__fuzionSwiperLoadPromise;
  }

  function parseOptions(el) {
    var raw = el.getAttribute('data-swiper-options');
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      console.warn('fuzion-swiper-slider: invalid data-swiper-options', el, e);
      return {};
    }
  }

  var PASSTHROUGH_OPTS = [
    'speed', 'resistanceRatio', 'allowTouchMove', 'simulateTouch', 'followFinger',
    'passiveListeners', 'touchReleaseOnEdges', 'effect', 'fadeEffect', 'direction',
    'centeredSlides', 'mousewheel', 'freeMode', 'slidesOffsetBefore'
  ];

  function buildSwiperOptions(component, opts) {
    var isMobile = window.innerWidth < MOBILE_BREAKPOINT;

    if (opts.disabledOnMobile && isMobile) return null;
    if (opts.disabledOnDesktop && !isMobile) return null;

    var section = component.closest('[data-section-id]');
    var nextEl = component.querySelector('.swiper-button-next') || component.querySelector('[class*="swiper-button-next"]');
    var prevEl = component.querySelector('.swiper-button-prev') || component.querySelector('[class*="swiper-button-prev"]');
    if (opts.navigation && typeof opts.navigation === 'object' && opts.navigation.nextEl && typeof opts.navigation.nextEl === 'string') {
      nextEl = (section && section.querySelector(opts.navigation.nextEl))
        || component.querySelector(opts.navigation.nextEl)
        || nextEl;
      prevEl = (section && section.querySelector(opts.navigation.prevEl))
        || component.querySelector(opts.navigation.prevEl)
        || prevEl;
    }
    var nav = (nextEl && prevEl) ? { nextEl: nextEl, prevEl: prevEl } : (opts.navigation && typeof opts.navigation === 'object' && !opts.navigation.nextEl ? opts.navigation : false);

    var pagEl = (opts.paginationEl
      ? ((section && section.querySelector(opts.paginationEl)) || component.querySelector(opts.paginationEl))
      : null)
      || component.querySelector(':scope > .swiper-pagination')
      || component.querySelector('.swiper-pagination')
      || component.querySelector('.swiper-pagination-testi');

    var pagination = false;
    if (pagEl && opts.pagination !== false) {
      pagination = Object.assign({ el: pagEl, clickable: true }, opts.pagination && typeof opts.pagination === 'object' ? opts.pagination : {});
    } else if (!pagEl && opts.pagination) {
      pagination = opts.pagination === true ? { clickable: true } : opts.pagination;
    }

    var wrapper = component.querySelector('.swiper-wrapper');
    var slideCount = wrapper ? wrapper.querySelectorAll('.swiper-slide').length : 0;

    /* Product sliders: mimic legacy "main-v-pag" bullets when pagination container
       uses the existing theme marker class "enable_pagination". Functions cannot
       be passed via JSON in data-swiper-options, so we attach here. */
    if (pagEl && pagination && pagEl.classList && pagEl.classList.contains('enable_pagination')) {
      pagination.renderBullet = function (index, className) {
        return (
          '<div class="main-v-pag">' +
          '<span class="' +
          className +
          '"></span>' +
          '<div class="v-slide-name">' +
          '<span class="slide-number">' +
          (index + 1) +
          '</span>' +
          '<span class="total-slides">' +
       
          '</span>' +
          '</div>' +
          '</div>'
        );
      };
    }

    var hasCustomBreakpoints = opts.breakpoints && typeof opts.breakpoints === 'object' && Object.keys(opts.breakpoints).length > 0;
    var breakpoints = hasCustomBreakpoints ? opts.breakpoints : {};
    if (!hasCustomBreakpoints) {
      breakpoints[MOBILE_BREAKPOINT] = {
        slidesPerView: opts.slidesPerViewDesktop !== undefined ? opts.slidesPerViewDesktop : 3,
        spaceBetween: opts.spaceBetweenDesktop !== undefined ? opts.spaceBetweenDesktop : 12
      };
    }

    var base = {
      slidesPerView: opts.slidesPerView !== undefined ? opts.slidesPerView : 2,
      spaceBetween: opts.spaceBetweenMobile !== undefined ? opts.spaceBetweenMobile : 8,
      resistanceRatio: 0.72,
      navigation: nav,
      pagination: pagination,
      loop: opts.loop === true && slideCount > 1,
      allowTouchMove: true,
      simulateTouch: true,
      followFinger: true,
      watchOverflow: true,
      watchSlidesVisibility: true,
      breakpoints: breakpoints
    };

    for (var pi = 0; pi < PASSTHROUGH_OPTS.length; pi++) {
      var key = PASSTHROUGH_OPTS[pi];
      if (opts[key] !== undefined) base[key] = opts[key];
    }

    if (opts.autoplay) {
      base.autoplay = typeof opts.autoplay === 'object'
        ? opts.autoplay
        : { delay: 5000, disableOnInteraction: false };
    }

    if (opts.scrollbar) {
      var scrollbarEl = component.querySelector('.swiper-scrollbar') || (section && opts.scrollbar.el ? section.querySelector(opts.scrollbar.el) : null);
      if (scrollbarEl) {
        base.scrollbar = { el: scrollbarEl, draggable: opts.scrollbar.draggable !== false };
        if (opts.scrollbar.dragSize !== undefined) base.scrollbar.dragSize = opts.scrollbar.dragSize;
      }
    }

    /* Video container: data-swiper-options cannot provide renderBullet (function), a11y overrides, or on.init.
       So we apply video-specific behaviour here when the element has class video-swiper-container.
       navigation_style comes from data-navigation-style attribute or opts.navigationStyle (e.g. navigation_style_2 / navigation_style_standard). */
    if (component.classList.contains('video-swiper-container')) {
      base.slidesPerView = 1;
      base.spaceBetween = 0;
      base.breakpoints = {};
      base.effect = 'fade';
      base.loop = slideCount > 1;
      base.allowTouchMove = true;
      base.simulateTouch = true;
      base.followFinger = true;
      base.threshold = 5;
      base.touchReleaseOnEdges = true;
      var delayAttr = component.getAttribute('delay');
      var delayNum = delayAttr ? (parseInt(delayAttr, 10) || 5000) : (opts.autoplay && opts.autoplay.delay) || 5000;
      var autoAttr = component.getAttribute('auto');
      base.autoplay = (autoAttr === 'true' || autoAttr === '1' || (opts.autoplay && opts.autoplay !== false))
        ? { delay: delayNum, speed: 2000, disableOnInteraction: false }
        : false;
      base.a11y = { enabled: false };
      var navStyle = component.getAttribute('data-navigation-style') || opts.navigationStyle || opts.navigation_style || '';
      var isStandardNav = navStyle === 'navigation_style_2' || navStyle === 'navigation_style_standard';
      if (pagEl && base.pagination) {
        var videoSlides = component.querySelectorAll('.swiper-slide');
        base.pagination.renderBullet = function (index, className) {
          var prefix = '<div class="main-v-pag"><span class="' + className + '"></span><div class="v-slide-name"><span class="slide-number">' + (index + 1) + '.</span>';
          if (isStandardNav) return prefix + '</div></div>';
          var slideName = (videoSlides[index] && videoSlides[index].getAttribute('data-name')) || '';
          return prefix + '<span class="slide-name">' + slideName + '</span></div></div>';
        };
      }
      var existingOn = base.on || {};
      base.on = {
        init: function (swiper) {
          var btns = component.querySelectorAll('.swiper-button-next, .swiper-button-prev, .swiper-pagination-bullet');
          for (var b = 0; b < btns.length; b++) { btns[b].setAttribute('tabindex', '-1'); btns[b].setAttribute('aria-hidden', 'true'); }
          var activeSlide = swiper.slides[swiper.activeIndex];
          if (activeSlide) {
            var vid = activeSlide.querySelector('video');
            if (vid) {
              var p = vid.play();
              if (p !== undefined) p.catch(function () { vid.addEventListener('canplay', function fn() { vid.removeEventListener('canplay', fn); vid.play().catch(function(){}); }, { once: true }); });
            }
          }
          if (typeof existingOn.init === 'function') existingOn.init.apply(this, arguments);
        },
        slideChangeTransitionEnd: function (swiper) {
          var allSlides = swiper.slides;
          for (var i = 0; i < allSlides.length; i++) {
            var vid = allSlides[i].querySelector('video');
            if (!vid) continue;
            if (i === swiper.activeIndex) {
              var p = vid.play();
              if (p !== undefined) p.catch(function () { vid.addEventListener('canplay', function fn() { vid.removeEventListener('canplay', fn); vid.play().catch(function(){}); }, { once: true }); });
            } else {
              vid.pause();
            }
          }
          if (typeof existingOn.slideChangeTransitionEnd === 'function') existingOn.slideChangeTransitionEnd.apply(this, arguments);
        }
      };
      for (var ek in existingOn) { if (ek !== 'init' && ek !== 'slideChangeTransitionEnd' && Object.prototype.hasOwnProperty.call(existingOn, ek)) base.on[ek] = existingOn[ek]; }
    }

    return base;
  }

  function registerWithTheme(component, swiperInstance) {
    if (typeof window.registerThemeSwiper === 'function') {
      // Pass the component (slider container) so main.js can call item.el.swiper.update()
      window.registerThemeSwiper(component, swiperInstance);
    }
  }

  /**
   * Wait for the thumbs element (from thumbsEl selector) to have a Swiper instance, then resolve with it.
   * @param {string} selector - CSS selector for the thumbnail slider container
   * @param {HTMLElement} component - This slider element (used to resolve section)
   * @returns {Promise<Swiper|null>}
   */
  function waitForThumbsSwiper(selector, component) {
    var section = component.closest('[data-section-id]');
    var el = (section && section.querySelector(selector)) || document.querySelector(selector);
    if (!el) return Promise.resolve(null);
    if (el.swiper) return Promise.resolve(el.swiper);
    return new Promise(function (resolve) {
      var attempts = 0;
      var interval = setInterval(function () {
        if (el.swiper) {
          clearInterval(interval);
          resolve(el.swiper);
        } else if (++attempts >= 60) {
          clearInterval(interval);
          resolve(null);
        }
      }, 100);
    });
  }

  if (typeof customElements === 'undefined' || customElements.get('fuzion-swiper-slider')) return;

  /**
   * Shop the look: pagination-one is on left-content (image), pagination-two below slider.
   * Duplicate bullets into pagination-two with click handlers; keep active state in sync via realIndex.
   * Uses slide count as source of truth and retries so all bullets appear (Swiper may render them async).
   */
  function initShopLookPagination(container, swiper) {
    var wrapper = container.closest('.fusion-shoplook-wrapper');
    if (!wrapper) return;
    var pagOne = wrapper.querySelector('.left-content .swiper-pagination-one') || container.querySelector('.swiper-pagination-one');
    var pagTwo = container.querySelector('.swiper-pagination-two');
    if (!pagOne || !pagTwo) return;

    function getSlideCount() {
      var slides = container.querySelectorAll('.swiper-wrapper .swiper-slide');
      return slides ? slides.length : (swiper.slides && swiper.slides.length) || 0;
    }

    function setActiveByIndex(activeIndex) {
      var bulletsOne = pagOne.querySelectorAll('.swiper-pagination-bullet');
      var bulletsTwo = pagTwo.querySelectorAll('.swiper-pagination-bullet');
      bulletsOne.forEach(function (b, i) {
        if (i === activeIndex) {
          b.classList.add('swiper-pagination-bullet-active');
          b.setAttribute('aria-current', 'true');
        } else {
          b.classList.remove('swiper-pagination-bullet-active');
          b.removeAttribute('aria-current');
        }
      });
      bulletsTwo.forEach(function (b, i) {
        if (i === activeIndex) {
          b.classList.add('swiper-pagination-bullet-active');
          b.setAttribute('aria-current', 'true');
        } else {
          b.classList.remove('swiper-pagination-bullet-active');
          b.removeAttribute('aria-current');
        }
      });
    }

    function duplicatePagination() {
      var bulletsOne = pagOne.querySelectorAll('.swiper-pagination-bullet');
      var expectedSlides = getSlideCount();
      if (expectedSlides === 0) return;
      if (bulletsOne.length < expectedSlides) {
        for (var i = bulletsOne.length; i < expectedSlides; i++) {
          var bullet = document.createElement('span');
          bullet.className = 'swiper-pagination-bullet';
          bullet.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          bullet.addEventListener('click', function (idx) {
            return function (e) {
              e.preventDefault();
              swiper.slideTo(idx);
            };
          }(i));
          pagOne.appendChild(bullet);
        }
        bulletsOne = pagOne.querySelectorAll('.swiper-pagination-bullet');
      }
      if (bulletsOne.length === 0) return;
      if (pagTwo.querySelectorAll('.swiper-pagination-bullet').length !== bulletsOne.length) {
        pagTwo.innerHTML = '';
        bulletsOne.forEach(function (b, i) {
          var clone = b.cloneNode(true);
          clone.classList.remove('swiper-pagination-bullet-active');
          clone.removeAttribute('aria-current');
          clone.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          clone.addEventListener('click', function (e) {
            e.preventDefault();
            swiper.slideTo(i);
          });
          pagTwo.appendChild(clone);
        });
      }
      setActiveByIndex(typeof swiper.realIndex !== 'undefined' ? swiper.realIndex : swiper.activeIndex);
    }

    function runDuplicateWithRetry() {
      duplicatePagination();
      var expected = getSlideCount();
      var got = pagOne.querySelectorAll('.swiper-pagination-bullet').length;
      if (expected > 0 && got < expected) {
        setTimeout(function () {
          duplicatePagination();
          got = pagOne.querySelectorAll('.swiper-pagination-bullet').length;
          if (got < expected) setTimeout(duplicatePagination, 100);
        }, 50);
      }
    }

    swiper.on('init', runDuplicateWithRetry);
    swiper.on('update', duplicatePagination);
    swiper.on('slideChangeTransitionEnd', function () { setActiveByIndex(swiper.realIndex); });
    setTimeout(runDuplicateWithRetry, 0);
  }

  function FuzionSwiperSliderElement() {
    var self = Reflect.construct(HTMLElement, arguments, FuzionSwiperSliderElement);
    self._opts = null;
    self._slider = null;
    self._observer = null;
    self._hoverTarget = null;
    self._onMouseEnter = null;
    self._onMouseLeave = null;
    return self;
  }
  FuzionSwiperSliderElement.prototype = Object.create(HTMLElement.prototype);
  FuzionSwiperSliderElement.prototype.constructor = FuzionSwiperSliderElement;

  FuzionSwiperSliderElement.prototype.connectedCallback = function () {
    var self = this;
    self._opts = parseOptions(self);

    function init(thumbSwiperInstance) {
      if (self._slider) return;
      var opts = buildSwiperOptions(self, self._opts);
      if (!opts) return;
      var wrapper = self.querySelector('.swiper-wrapper');
      if (!wrapper || !wrapper.querySelector('.swiper-slide')) return;
      if (typeof window.Swiper !== 'function') return;
      if (thumbSwiperInstance) opts.thumbs = { swiper: thumbSwiperInstance };
      try {
        self._slider = new window.Swiper(self, opts);
        registerWithTheme(self, self._slider);
        /* Shop the look: duplicate pagination-one into pagination-two and keep active in sync */
        if (self.classList.contains('custom-pagination') && self.closest('.fusion-shoplook-wrapper')) {
          initShopLookPagination(self, self._slider);
        }
      } catch (err) {
        console.warn('fuzion-swiper-slider init error', err, self);
      }
    }

    function loadAndInit() {
      loadSwiperScript().then(function () {
        if (self._opts.thumbsEl && typeof self._opts.thumbsEl === 'string') {
          waitForThumbsSwiper(self._opts.thumbsEl, self).then(init, function () { init(null); });
        } else {
          init(null);
        }
      }, function () {});
    }

    /* Hover-init mode: Swiper is created on first mouseenter and autoplay is
       toggled on every enter/leave. The parent hover target defaults to the
       nearest .florence-product-card but can be overridden via data-hover-target. */
    if (self.hasAttribute('data-hover-init')) {
      var hoverSelector = self.getAttribute('data-hover-target') || '.florence-product-card';
      var hoverTarget = self.closest(hoverSelector) || self.parentElement;

      self._onMouseEnter = function () {
        /* Clone deferred slides from <template> into swiper-wrapper on first hover */
        var deferredTmpl = self.querySelector('template.deferred-slides');
        if (deferredTmpl) {
          var wrapper = self.querySelector('.swiper-wrapper');
          if (wrapper) {
            wrapper.appendChild(deferredTmpl.content.cloneNode(true));
          }
          deferredTmpl.remove();
        }
        loadSwiperScript().then(function () {
          if (!self._slider) {
            init(null);
          }
          if (self._slider && self._slider.autoplay) {
            self._slider.autoplay.start();
          }
        }, function () {});
      };

      self._onMouseLeave = function () {
        if (self._slider && self._slider.autoplay) {
          self._slider.autoplay.stop();
        }
      };

      self._hoverTarget = hoverTarget;
      hoverTarget.addEventListener('mouseenter', self._onMouseEnter);
      hoverTarget.addEventListener('mouseleave', self._onMouseLeave);
      return;
    }

    if (typeof IntersectionObserver !== 'function') {
      loadAndInit();
      return;
    }
    self._observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].target !== self || !entries[i].isIntersecting) continue;
          if (self._observer) self._observer.disconnect();
          self._observer = null;
          loadAndInit();
          break;
        }
      },
      { rootMargin: DEFAULT_ROOT_MARGIN, threshold: DEFAULT_THRESHOLD }
    );
    self._observer.observe(self);
  };

  FuzionSwiperSliderElement.prototype.disconnectedCallback = function () {
    if (this._hoverTarget && this._onMouseEnter) {
      this._hoverTarget.removeEventListener('mouseenter', this._onMouseEnter);
      this._hoverTarget.removeEventListener('mouseleave', this._onMouseLeave);
      this._hoverTarget = null;
      this._onMouseEnter = null;
      this._onMouseLeave = null;
    }
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    if (this._slider && typeof this._slider.destroy === 'function') {
      this._slider.destroy(true, true);
    }
    this._slider = null;
  };

  FuzionSwiperSliderElement.prototype.initSlider = function () {
    if (this._slider) return;
    var opts = this._opts || parseOptions(this);
    var built = buildSwiperOptions(this, opts);
    if (!built || typeof window.Swiper !== 'function') return;
    this._slider = new window.Swiper(this, built);
    registerWithTheme(this, this._slider);
  };

  customElements.define('fuzion-swiper-slider', FuzionSwiperSliderElement);

  /**
   * Initialize quickview popup gallery + thumbnail sliders when a modal becomes active.
   * Loads Swiper if needed (modal is hidden until open so Swiper may not be loaded yet).
   */
  function initQuickviewInModal(modal) {
    if (!modal || typeof modal.querySelector !== 'function') return;
    var gallery = modal.querySelector('.quickview-slider-gallery');
    if (!gallery) return;
    var dif_cout = gallery.getAttribute('data-dif-cout');
    if (!dif_cout) return;
    var thumbnailEl = modal.querySelector('.thumbnail-' + dif_cout);
    var sliderEl = modal.querySelector('.slider-' + dif_cout);
    if (!thumbnailEl || !sliderEl || sliderEl.swiper) return;

    try {
      if (thumbnailEl.swiper && thumbnailEl.swiper.destroy) thumbnailEl.swiper.destroy(true, true);
      if (sliderEl.swiper && sliderEl.swiper.destroy) sliderEl.swiper.destroy(true, true);
      thumbnailEl.swiper = sliderEl.swiper = null;
    } catch (e) { /* ignore */ }

    if (typeof window.Swiper !== 'function') return;
    var thumbnailImages = thumbnailEl.querySelectorAll('img');
    var imagesToLoad = Array.prototype.filter.call(thumbnailImages, function (img) { return !img.complete; });

    function initSlider() {
      var thumbSwiper = new window.Swiper(thumbnailEl, {
        slidesPerView: 4,
        spaceBetween: 20,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          320: { slidesPerView: 1.1, spaceBetween: 13 },
          515: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 20 },
          1460: { slidesPerView: 4, spaceBetween: 20 }
        }
      });
      new window.Swiper(sliderEl, {
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: modal.querySelector('.button-next-' + dif_cout),
          prevEl: modal.querySelector('.button-prev-' + dif_cout)
        },
        thumbs: { swiper: thumbSwiper }
      });
      setTimeout(function () {
        if (thumbSwiper && thumbSwiper.update) {
          thumbSwiper.update();
          thumbSwiper.updateSlides();
          thumbSwiper.updateSize();
          thumbSwiper.updateSlidesClasses();
          if (thumbSwiper.slides) {
            for (var i = 0; i < thumbSwiper.slides.length; i++) {
              if (thumbSwiper.slides[i].style) thumbSwiper.slides[i].style.width = '';
            }
          }
          thumbSwiper.update();
        }
        if (sliderEl.swiper && sliderEl.swiper.update) {
          sliderEl.swiper.update();
          sliderEl.swiper.updateSize();
        }
      }, 300);
      setTimeout(function () {
        if (thumbSwiper && thumbSwiper.update) {
          thumbSwiper.update();
          thumbSwiper.updateSlides();
          thumbSwiper.updateSize();
        }
        if (sliderEl.swiper && sliderEl.swiper.update) sliderEl.swiper.update();
      }, 500);
    }

    if (imagesToLoad.length > 0) {
      var loadedCount = 0;
      var initCalled = false;
      function tryInit() {
        if (!initCalled && loadedCount === imagesToLoad.length) {
          initCalled = true;
          initSlider();
        }
      }
      for (var j = 0; j < imagesToLoad.length; j++) {
        imagesToLoad[j].addEventListener('load', function () { loadedCount++; tryInit(); });
        imagesToLoad[j].addEventListener('error', function () { loadedCount++; tryInit(); });
      }
      setTimeout(function () {
        if (!initCalled) { initCalled = true; initSlider(); }
      }, 1000);
    } else {
      initSlider();
    }
  }

  function onQuickviewModalOpened(modal) {
    loadSwiperScript().then(
      function () { initQuickviewInModal(modal); },
      function () { initQuickviewInModal(modal); }
    );
  }

  // Expose functions globally so the on-demand quickview JS in main.js can call them
  window.onQuickviewModalOpened = onQuickviewModalOpened;
  window.initQuickviewInModal = initQuickviewInModal;

  // Watch the global quickview modal for class changes to initialize swipers
  if (typeof MutationObserver !== 'undefined') {
    var quickviewObserver = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var el = mutations[m].target;
        if (mutations[m].attributeName === 'class' && el.classList && el.classList.contains('PopupModal-quickView-wrapper') && el.classList.contains('active')) {
          onQuickviewModalOpened(el);
        }
      }
    });
    document.addEventListener('DOMContentLoaded', function () {
      // Observe the single global quickview modal
      var globalModal = document.getElementById('quickview-modal-global');
      if (globalModal) {
        quickviewObserver.observe(globalModal, { attributes: true, attributeFilter: ['class'] });
      }
    });
  }

  window.__fuzionLoadSwiper = loadSwiperScript;

  /**
   * Initialize product gallery swipers (.pdp_slider, .mobile_pdp_slider) inside fuzion-media-viewer.
   * These are plain divs (not fuzion-swiper-slider). Ensures el.swiper exists so fuzion-media-viewer
   * can attach pause-on-slide-change and slideChanged is dispatched for thumbnail sync.
   */
  function initProductGallerySwipers() {
    if (typeof window.Swiper !== 'function') return;
    var viewers = document.querySelectorAll('fuzion-media-viewer');
    viewers.forEach(function (viewer) {
      var containers = viewer.querySelectorAll('.pdp_slider, .mobile_pdp_slider');
      containers.forEach(function (el) {
        if (el.swiper) return;
        var wrapper = el.querySelector('.swiper-wrapper');
        if (!wrapper || !wrapper.querySelector('.swiper-slide')) return;
        var viewerEl = el.closest('[id^="GalleryViewer"]');
        var nextEl = el.querySelector('.swiper-button-next');
        var prevEl = el.querySelector('.swiper-button-prev');
        var pagEl = el.querySelector('.swiper-pagination');
        var slideCount = wrapper.querySelectorAll('.swiper-slide').length;
        var videoSlides = el.querySelectorAll('.swiper-slide');
        var paginationOpts = false;
        if (pagEl) {
          paginationOpts = { el: pagEl, clickable: true };
          if (pagEl.classList.contains('enable_pagination')) {
            paginationOpts.renderBullet = function (index, className) {
              var slideName = (videoSlides[index] && videoSlides[index].getAttribute('data-name')) || '';
              return '<div class="main-v-pag"><span class="' + className + '"></span><div class="v-slide-name"><span class="slide-number">' + (index + 1) + '.</span><span class="slide-name">' + slideName + '</span></div></div>';
            };
          }
        }
        var config = {
          slidesPerView: 1,
          spaceBetween: el.classList.contains('mobile_pdp_slider') ? 10 : 0,
          loop: (el.dataset && el.dataset.loop === 'true' && slideCount > 1),
          allowTouchMove: true,
          navigation: (nextEl && prevEl) ? { nextEl: nextEl, prevEl: prevEl } : false,
          pagination: paginationOpts,
          on: {
            slideChangeTransitionEnd: function (swiper) {
              if (viewerEl && swiper.slides && swiper.slides[swiper.activeIndex]) {
                viewerEl.dispatchEvent(new CustomEvent('slideChanged', { detail: { currentElement: swiper.slides[swiper.activeIndex] } }));
              }
            }
          }
        };
        try {
          var swiperInstance = new window.Swiper(el, config);
          registerWithTheme(el, swiperInstance);
        } catch (err) {
          console.warn('swiper-slider-component: product gallery init error', err, el);
        }
      });
    });
    document.dispatchEvent(new CustomEvent('fuzion-product-gallery-swiper-ready'));
  }

  function runProductGallerySwipers() {
    loadSwiperScript().then(function () {
      initProductGallerySwipers();
    }, function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runProductGallerySwipers);
  } else {
    runProductGallerySwipers();
  }
  window.addEventListener('shopify:section:load', function (e) {
    var section = e.detail && e.detail.sectionId;
    if (!section) return;
    var root = document.getElementById('shopify-section-' + section);
    if (!root) return;
    var nodes = root.querySelectorAll('fuzion-swiper-slider');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el._slider && typeof el._slider.destroy === 'function') el._slider.destroy(true, true);
      el._slider = null;
      el._opts = parseOptions(el);
    }
    var galleryContainers = root.querySelectorAll('.pdp_slider, .mobile_pdp_slider');
    for (var j = 0; j < galleryContainers.length; j++) {
      var c = galleryContainers[j];
      if (c.swiper && typeof c.swiper.destroy === 'function') c.swiper.destroy(true, true);
      c.swiper = null;
      c._pauseAllMediaAttached = undefined;
    }
    loadSwiperScript().then(function () {
      for (var i = 0; i < nodes.length; i++) nodes[i].initSlider();
      initProductGallerySwipers();
    }, function () {});
  });
})();

if (!customElements.get('fuzion-hero-banner-slider')) {
  var HeroBannerSliderCubic = 'cubic-bezier(0.45, 0.00, 0.15, 0.95)';
  var HeroBannerSliderTransitionMs = '1000ms';

  class FuzionHeroBannerSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.lastActiveIndex = null;
      var isDesignMode = typeof window.Shopify !== 'undefined' && window.Shopify.designMode;
      this.isDesignMode = !!isDesignMode;
      if (isDesignMode) {
        this.classList.add('is-design-mode');
        window.addEventListener('shopify:section:load', () => {
          var loader = window.__fuzionLoadSwiper || (function noop() { return Promise.resolve(); });
          loader().then(() => this.initHeroSlider());
        });
      }
      window.addEventListener('shopify:block:select', (ev) => {
        var blockIndex = ev.target && ev.target.dataset && ev.target.dataset.index;
        var hasSlider = this.slider && !this.slider.destroyed;
        var isOwnTarget = this.contains && this.contains(ev.target);
        if (blockIndex != null && isOwnTarget && hasSlider) {
          this.slider.slideTo(parseInt(blockIndex, 10), 600);
        }
      });
      this.attachHeroKeyboardNav();
    }

    connectedCallback() {
      var loader = window.__fuzionLoadSwiper || (function noop() { return Promise.resolve(); });
      loader().then(() => this.initHeroSlider());
    }

    disconnectedCallback() {
      var inst = this.slider;
      if (inst && typeof inst.destroy === 'function') {
        inst.destroy(true, true);
      }
      this.slider = null;
    }

    readHeroSliderOpts() {
      var jsonStr = this.getAttribute('data-swiper-options');
      if (!jsonStr) return {};
      try {
        return JSON.parse(jsonStr);
      } catch (err) {
        console.warn('fuzion-hero-banner-slider: invalid data-swiper-options', err);
        return {};
      }
    }

    initHeroSlider() {
      if (typeof window.Swiper !== 'function') {
        setTimeout(() => this.initHeroSlider(), 150);
        return;
      }
      var inst = this.slider;
      if (inst && typeof inst.destroy === 'function') {
        inst.destroy(true, true);
        this.slider = null;
      }

      var opts = this.readHeroSliderOpts();

      /* Clone deferred hero slides from <template> into swiper-wrapper */
      var deferredTmpl = this.querySelector('template.deferred-hero-slides');
      if (deferredTmpl) {
        var wrapper = this.querySelector('.swiper-wrapper');
        if (wrapper) {
          wrapper.appendChild(deferredTmpl.content.cloneNode(true));
        }
        deferredTmpl.remove();
      }

      this.classList.add('swiper');
      var slideNodes = this.querySelectorAll('.swiper-slide');
      var slideCount = slideNodes ? slideNodes.length : 0;
      if (slideCount === 0) return;

      if (this.isDesignMode) {
        this.style.width = '100%';
        this.style.maxWidth = '100%';
        if (!this.style.minHeight) {
          this.style.minHeight = '100vh';
        }
        for (var i = 0; i < slideCount; i++) {
          var slideEl = slideNodes[i];
          if (!slideEl) continue;
          slideEl.style.width = '100%';
          slideEl.style.minWidth = '100%';
        }
      }

      var speedMs = opts.speed !== undefined ? opts.speed : 1000;
      var autoplayDelay = typeof opts.delay === 'number' ? opts.delay : (parseInt(opts.delay, 10) || 3000);
      var useSlidePage = opts.slidePage === true;
      var useStandardNavStyle = opts.navigationStyle === 'navigation_style_standard';

      var btnNext = this.querySelector('.swiper-button-next');
      var btnPrev = this.querySelector('.swiper-button-prev');
      var navOpts = opts.navigation;
      var sectionRoot = this.closest && this.closest('[data-section-id]');
      if (navOpts && typeof navOpts === 'object' && navOpts.nextEl && sectionRoot) {
        btnNext = sectionRoot.querySelector(navOpts.nextEl) || btnNext;
        btnPrev = sectionRoot.querySelector(navOpts.prevEl) || btnPrev;
      }
      var navConfig = (btnNext && btnPrev) ? { nextEl: btnNext, prevEl: btnPrev } : false;

      var config = {
        slidesPerView: opts.slidesPerView !== undefined ? opts.slidesPerView : 1,
        spaceBetween: opts.spaceBetween !== undefined ? opts.spaceBetween : 0,
        speed: speedMs,
        loop: opts.loop !== false,
        effect: opts.effect || 'fade',
        followFinger: opts.followFinger !== undefined ? opts.followFinger : false,
        passiveListeners: false,
        touchEventsTarget: 'wrapper',
        touchReleaseOnEdges: opts.touchReleaseOnEdges !== false,
        resistanceRatio: opts.resistanceRatio !== undefined ? opts.resistanceRatio : 0,
        navigation: navConfig,
        pagination: false,
        autoplay: false,
        on: {
          init: this.onHeroSlideChange.bind(this),
          slideChange: this.onHeroSlideChange.bind(this)
        }
      };

      if (useSlidePage) {
        var pagEl = this.querySelector('.swiper-pagination');
        if (pagEl) {
          var totalSlides = slideCount;
          config.pagination = {
            el: pagEl,
            clickable: true,
            renderBullet: function (index, className) {
              if (useStandardNavStyle) {
                return '<div class="main-v-pag"><span class="' + className + '"></span><div class="v-slide-name"><span class="slide-number">' + (index + 1) + '</span></div></div>';
              }
              return '<div class="main-v-pag" data-index="' + index + '"><span class="' + className + '"></span><div class="v-slide-name"><span class="slide-number">' + (index + 1) + '</span><span class="total-slides">/' + totalSlides + '</span></div></div>';
            }
          };
        }
      }

      var autoplayCfg = opts.autoplay;
      if (autoplayCfg === true || (autoplayCfg && typeof autoplayCfg === 'object')) {
        config.autoplay = (typeof autoplayCfg === 'object' && autoplayCfg !== null)
          ? { delay: autoplayDelay, disableOnInteraction: false, ...autoplayCfg }
          : { delay: autoplayDelay, disableOnInteraction: false };
      }

      this.slider = new Swiper(this, config);
      if (typeof window.registerThemeSwiper === 'function') {
        window.registerThemeSwiper(this, this.slider);
      }

      this.addEventListener('click', (ev) => {
        var clicked = ev.target && ev.target.closest && ev.target.closest('.main-v-pag');
        if (!clicked) return;
        var dataIndex = clicked.getAttribute('data-index');
        if (dataIndex != null && this.slider && !this.slider.destroyed) {
          this.slider.slideToLoop(parseInt(dataIndex, 10));
        }
      });
    }

    onHeroSlideChange(swiper) {
      this.runHeroSlideAnimations(swiper);
    }

    runHeroSlideAnimations(swiper) {
      var baseDelay = 300;
      var wrapper = swiper.wrapperEl;
      var activeSlide = wrapper && wrapper.querySelector && wrapper.querySelector('[data-index="' + swiper.activeIndex + '"]');
      var animEls = activeSlide ? (activeSlide.querySelectorAll && activeSlide.querySelectorAll('.hero__animation') || []) : [];
      if (!animEls.length) return;

      for (var i = 0; i < animEls.length; i++) {
        animEls[i].classList.add('in-delay');
      }

      var prevIdx = this.lastActiveIndex;
      var currIdx = swiper.activeIndex;
      if (prevIdx > currIdx) {
        baseDelay = 650 + baseDelay;
        if (wrapper) {
          wrapper.style.transitionDuration = HeroBannerSliderTransitionMs;
          wrapper.style.transitionTimingFunction = HeroBannerSliderCubic;
        }
      } else if (prevIdx < currIdx) {
        baseDelay = 1000 + baseDelay;
        if (wrapper) {
          wrapper.style.transitionDuration = HeroBannerSliderTransitionMs;
          wrapper.style.transitionTimingFunction = HeroBannerSliderCubic;
        }
      }

      var delayForItems = baseDelay;
      setTimeout(() => {
        if (prevIdx > currIdx) delayForItems = 325 + delayForItems;
        else if (prevIdx < currIdx) delayForItems = 500 + delayForItems;
        for (var j = 0; j < animEls.length; j++) {
          if (j === 1) delayForItems = delayForItems + 50;
          else if (j === 2) delayForItems = delayForItems + 175;
          else if (j === 3) delayForItems = delayForItems + 300;
          animEls[j].classList.remove('in-delay');
        }
      }, delayForItems);
      this.lastActiveIndex = swiper.activeIndex;
    }

    attachHeroKeyboardNav() {
      var self = this;
      document.addEventListener('keydown', function (ev) {
        if (!self.isInViewport()) return;
        if (ev.key === 'ArrowRight') {
          var nextBtn = self.querySelector('.swiper-button-next');
          if (nextBtn) nextBtn.click();
        }
        if (ev.key === 'ArrowLeft') {
          var prevBtn = self.querySelector('.swiper-button-prev');
          if (prevBtn) prevBtn.click();
        }
      });
    }

    isInViewport() {
      var box = this.getBoundingClientRect();
      return box.top < window.innerHeight && box.bottom > 0 && box.left < window.innerWidth && box.right > 0;
    }
  }
  customElements.define('fuzion-hero-banner-slider', FuzionHeroBannerSlider);
}

if (!customElements.get('fuzion-filter-selector-slider')) {
  /**
   * Slider for filter/selector sections (e.g. collection tab with filterOptions).
   * Uses same data-swiper-options as fuzion-swiper-slider. Exposes .slider for update() when filters change.
   * Owns filter tab logic: selector bar, show/hide items, reset slider and scrollbar on tab change.
   */
  
  class FuzionFilterSelectorSlider extends HTMLElement {

    /* ---------------------------------------
     * CONSTRUCTOR
     * -------------------------------------*/
    constructor() {
      super();
  
      this.slider = null;
      this._filterUnsubscribe = null;
      this._resizeUnsubscribe = null;
  
      this.MOBILE_BREAKPOINT = 750;
      this._raf = null;
  
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
  
      const isDesignMode =
        typeof window.Shopify !== 'undefined' &&
        window.Shopify.designMode;
  
      if (isDesignMode) {
        window.addEventListener('shopify:section:load', () =>
          this.loadSwiper().then(() => this.init())
        );
      }
  
      window.addEventListener('shopify:block:select', this.handleBlockSelect);
    }
  
    /* ---------------------------------------
     * LIFECYCLE
     * -------------------------------------*/
    connectedCallback() {
      this.loadSwiper().then(() => this.init());
    }
  
    disconnectedCallback() {
      this.cleanup();
    }
  
    cleanup() {
      this._filterUnsubscribe?.();
      this._resizeUnsubscribe?.();
  
      window.removeEventListener(
        'shopify:block:select',
        this.handleBlockSelect
      );
  
      this.destroySlider();
    }
  
    destroySlider() {
      if (this.slider?.destroy) {
        this.slider.destroy(true, true);
      }
      this.slider = null;
    }
  
    /* ---------------------------------------
     * HELPERS
     * -------------------------------------*/
    loadSwiper() {
      const loader =
        window.__fuzionLoadSwiper ||
        (() => Promise.resolve());
  
      return loader();
    }
  
    readOptions() {
      try {
        return JSON.parse(
          this.getAttribute('data-swiper-options') || '{}'
        );
      } catch (e) {
        console.warn('Invalid swiper options', e);
        return {};
      }
    }
  
    isMobile() {
      return window.innerWidth < this.MOBILE_BREAKPOINT;
    }
  
    handleBlockSelect(ev) {
      const index = ev.target?.dataset?.index;
  
      if (
        index != null &&
        this.contains(ev.target) &&
        this.slider &&
        !this.slider.destroyed
      ) {
        this.slider.slideTo(parseInt(index, 10), 600);
      }
    }
  
    /* ---------------------------------------
     * INIT
     * -------------------------------------*/
    init() {
      if (typeof window.Swiper !== 'function') {
        setTimeout(() => this.init(), 150);
        return;
      }
  
      this.destroySlider();
  
      const opts = this.readOptions();
      const wrapper = this.querySelector('.swiper-wrapper');
      if (!wrapper) return;
  
      const slides = wrapper.querySelectorAll('.swiper-slide');
      if (!slides.length) return;
  
      if (
        (opts.disabledOnMobile && this.isMobile()) ||
        (opts.disabledOnDesktop && !this.isMobile())
      ) {
        return;
      }
  
      this.classList.add('swiper');
  
      const config = this.buildSwiperConfig(opts, slides.length);
      this.slider = new Swiper(this, config);
  
      window.registerThemeSwiper?.(this, this.slider);
  
      this.setupFilterAndSelector();
  
      requestAnimationFrame(() => {
        this.applyScrollbarDragWidth();
      });
    }
  
    /* ---------------------------------------
     * SWIPER CONFIG
     * -------------------------------------*/
    buildSwiperConfig(opts, slideCount) {
      const section = this.closest('[data-section-id]');
  
      const nav = this.resolveNavigation(opts, section);
      const pagination = this.resolvePagination(opts, section);
      const scrollbar = this.resolveScrollbar(opts, section);
  
      const config = {
        slidesPerView: opts.slidesPerView ?? 2,
        spaceBetween: opts.spaceBetweenMobile ?? 15,
        speed: opts.speed ?? 1000,
        loop: opts.loop === true && slideCount > 1,
        navigation: nav,
        pagination,
        scrollbar,
        allowTouchMove: opts.allowTouchMove ?? true,
        passiveListeners: false,
        touchEventsTarget: 'wrapper',
        resistanceRatio: opts.resistanceRatio ?? 0.72,
        watchSlidesVisibility: true,
        watchOverflow: true,
        observer: false,
        observeParents: false,
        breakpoints:
          opts.breakpoints || {
            [this.MOBILE_BREAKPOINT]: {
              slidesPerView: opts.slidesPerViewDesktop ?? 4,
              spaceBetween: opts.spaceBetweenDesktop ?? 30
            }
          }
      };
  
      if (opts.autoplay)
        config.autoplay =
          typeof opts.autoplay === 'object'
            ? opts.autoplay
            : { delay: 5000, disableOnInteraction: false };
  
      [
        'effect',
        'fadeEffect',
        'direction',
        'centeredSlides',
        'mousewheel',
        'freeMode',
        'slidesOffsetBefore'
      ].forEach(key => {
        if (opts[key] !== undefined) config[key] = opts[key];
      });
  
      config.on = {
        slideChangeTransitionEnd: () => {}
      };
  
      return config;
    }
  
    resolveNavigation(opts, section) {
      let next = this.querySelector('.swiper-button-next');
      let prev = this.querySelector('.swiper-button-prev');
  
      if (opts.navigation && section) {
        next = section.querySelector(opts.navigation.nextEl) || next;
        prev = section.querySelector(opts.navigation.prevEl) || prev;
      }
  
      return next && prev ? { nextEl: next, prevEl: prev } : false;
    }
  
    resolvePagination(opts, section) {
      if (opts.pagination === false) return false;
  
      let el =
        (opts.paginationEl && section?.querySelector(opts.paginationEl)) ||
        this.querySelector('.swiper-pagination');
  
      if (!el) return false;
  
      return { el, clickable: true, ...(opts.pagination || {}) };
    }
  
    resolveScrollbar(opts, section) {
      if (!opts.scrollbar) return false;
  
      let el =
        (opts.scrollbar.el && section?.querySelector(opts.scrollbar.el)) ||
        this.querySelector('.swiper-scrollbar');
  
      if (!el) return false;
  
      return {
        el,
        draggable: opts.scrollbar.draggable !== false,
        dragSize: opts.scrollbar.dragSize ?? 87
      };
    }
  
    /* ---------------------------------------
     * SCROLLBAR WIDTH
     * -------------------------------------*/
    applyScrollbarDragWidth() {
      const slider = this.slider;
      if (!slider?.scrollbar?.dragEl) return;
  
      const track = slider.scrollbar.el;
      const visibleSlides =
        this.querySelectorAll('.swiper-slide:not(.hide-anim)').length;
  
      const slidesPerView =
        Number(slider.params.slidesPerView) || 4;
  
      const trackWidth = track.clientWidth;
  
      let dragWidth =
        trackWidth * (slidesPerView / visibleSlides);
  
      dragWidth = Math.max(60, Math.min(trackWidth, dragWidth));
  
      slider.scrollbar.dragEl.style.width = dragWidth + 'px';
  
      slider.scrollbar.updateSize();
    }
  
    /* ---------------------------------------
     * FILTER + SELECTOR
     * -------------------------------------*/
    setupFilterAndSelector() {
      const section =
        this.closest('.fusion-collection-wrapper') ||
        this.closest('[id^="shopify-section-"]');
  
      if (!section) return;
  
      const tabsUL = section.querySelector('#filterOptions');
      const selectorBar = section.querySelector('.selector');
      const wrapper = this.querySelector('.swiper-wrapper');
  
      if (!tabsUL || !wrapper) return;
  
      const items = [...wrapper.querySelectorAll('.swiper-slide.item')];
  
      /* shuffle once */
      items.sort(() => Math.random() - 0.5)
        .forEach(el => wrapper.appendChild(el));
  
      const updateSelector = () => {
        if (this._raf) return;
  
        this._raf = requestAnimationFrame(() => {
          this._raf = null;
  
          const active =
            tabsUL.querySelector('.active > a');
  
          if (!active) return;
  
          selectorBar.style.left =
            active.offsetLeft - 1 + 'px';
          selectorBar.style.width =
            active.offsetWidth + 'px';
        });
      };
  
      updateSelector();
  
      const onResize = () => updateSelector();
      window.addEventListener('resize', onResize);
      this._resizeUnsubscribe = () =>
        window.removeEventListener('resize', onResize);
  
      const clickHandler = e => {
        const link = e.target.closest('a');
        if (!link) return;
  
        e.preventDefault();
  
        tabsUL
          .querySelectorAll('li')
          .forEach(li => li.classList.remove('active'));
  
        link.parentElement.classList.add('active');
  
        updateSelector();
  
        const filter = link.getAttribute('data-filter');
  
        items.forEach(item => {
          const match =
            filter === 'all' ||
            item.dataset.filter === filter;
  
          item.classList.toggle('hide-anim', !match);
          item.classList.toggle('show-anim', match);
        });
  
        this.refreshSlider();
      };
  
      tabsUL.addEventListener('click', clickHandler);
  
      this._filterUnsubscribe = () =>
        tabsUL.removeEventListener('click', clickHandler);
    }
  
    refreshSlider() {
      const slider = this.slider;
      if (!slider || slider.destroyed) return;
  
      const slides =
        this.querySelectorAll('.swiper-slide');
  
      slides.forEach(slide => {
        slide.style.display = slide.classList.contains('hide-anim')
          ? 'none'
          : '';
      });
  
      requestAnimationFrame(() => {
        slider.updateSlides();
        slider.updateSize();
        slider.update();
        slider.slideTo(0, 0, false);
  
        requestAnimationFrame(() => {
          this.applyScrollbarDragWidth();
          slider.updateProgress(0);
          slider.setTranslate(0);
        });
      });
    }
  }


customElements.define(
  'fuzion-filter-selector-slider',
  FuzionFilterSelectorSlider
);

}

if (!customElements.get('fuzion-video-slider')) {
  class FuzionVideoSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      var isDesignMode = typeof window.Shopify !== 'undefined' && window.Shopify.designMode;
      if (isDesignMode) {
        window.addEventListener('shopify:section:load', () => {
          var loader = window.__fuzionLoadSwiper || (function noop() { return Promise.resolve(); });
          loader().then(() => this.initVideoSlider());
        });
      }
    }

    connectedCallback() {
      var loader = window.__fuzionLoadSwiper || (function noop() { return Promise.resolve(); });
      loader().then(() => this.initVideoSlider());
    }

    disconnectedCallback() {
      var inst = this.slider;
      if (inst && typeof inst.destroy === 'function') {
        inst.destroy(true, true);
      }
      this.slider = null;
    }

    initVideoSlider() {
      if (typeof window.Swiper !== 'function') {
        setTimeout(() => this.initVideoSlider(), 150);
        return;
      }
      var inst = this.slider;
      if (inst && typeof inst.destroy === 'function') {
        inst.destroy(true, true);
        this.slider = null;
      }

      this.classList.add('swiper');
      var slideNodes = this.querySelectorAll('.swiper-slide');
      var slideCount = slideNodes ? slideNodes.length : 0;
      if (slideCount === 0) return;

      var delayAttr = this.getAttribute && this.getAttribute('delay');
      var delayNum = delayAttr ? (parseInt(delayAttr, 10) || 5000) : 5000;
      var autoAttr = this.getAttribute && this.getAttribute('auto');
      var autoplayEnabled = autoAttr === 'true' || autoAttr === '1';
      var loopAttr = this.getAttribute && (this.getAttribute('data-loop') || this.getAttribute('loop'));
      var loopEnabled = loopAttr === 'true' || loopAttr === '1';
      var videoSlides = this.querySelectorAll('.swiper-slide') || [];
      var selfVideo = this;

      var config = {
        loop: loopEnabled && slideCount > 1,
        effect: 'fade',
        autoplay: autoplayEnabled
          ? {
              delay: delayNum,
              speed: 2000,
              disableOnInteraction: false,
            }
          : false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            var slideName = (videoSlides[index] && videoSlides[index].getAttribute && videoSlides[index].getAttribute('data-name')) || '';
            return (
              '<div class="main-v-pag">' +
              '<span class="' + className + '"></span>' +
              '<div class="v-slide-name">' +
              '<span class="slide-number">' + (index + 1) + '.</span>' +
              '<span class="slide-name">' + slideName + '</span>' +
              '</div>' +
              '</div>'
            );
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        a11y: {
          enabled: false,
        },
        on: {
          init: function (swiper) {
            var btns = selfVideo.querySelectorAll('.swiper-button-next, .swiper-button-prev, .swiper-pagination-bullet');
            if (btns) {
              for (var b = 0; b < btns.length; b++) {
                btns[b].setAttribute('tabindex', '-1');
                btns[b].setAttribute('aria-hidden', 'true');
              }
            }
            var activeSlide = swiper.slides[swiper.activeIndex];
            if (activeSlide) {
              var vid = activeSlide.querySelector('video');
              if (vid) selfVideo.playVideoWhenReady(vid);
            }
          },
          slideChangeTransitionEnd: function (swiper) {
            var allSlides = swiper.slides;
            for (var i = 0; i < allSlides.length; i++) {
              var vid = allSlides[i].querySelector('video');
              if (!vid) continue;
              if (i === swiper.activeIndex) {
                selfVideo.playVideoWhenReady(vid);
              } else {
                vid.pause();
              }
            }
          },
        },
      };

      this.slider = new Swiper(this, config);
      if (typeof window.registerThemeSwiper === 'function') {
        window.registerThemeSwiper(this, this.slider);
      }
    }

    playVideoWhenReady(vid) {
      var p = vid.play();
      if (p !== undefined) {
        p.catch(() => {
          vid.addEventListener('canplay', function onCanPlay() {
            vid.removeEventListener('canplay', onCanPlay);
            vid.play().catch(function () {});
          }, { once: true });
        });
      }
    }
  }
  customElements.define('fuzion-video-slider', FuzionVideoSlider);
}

/**
 * Legacy initializer (pre web-components) for musk product slider.
 * Keeps compatibility with older markup that uses attributes like:
 * - speed="2000"
 * - data-slidesperview="4"
 * - autoplayslider="true|false"
 * - data-navigation_pagination="true|false"
 *
 * Notes:
 * - If the element is a <fuzion-swiper-slider>, it will be initialized by the web component already.
 * - We skip elements that already have a Swiper instance.
 */
function initializeMuskPRODUCTSlider1() {
  var nodes = document.querySelectorAll('.fusion-product-slider1');
  if (!nodes || nodes.length === 0) return;

  var loader = window.__fuzionLoadSwiper || function noop() { return Promise.resolve(); };

  loader().then(function () {
    if (typeof window.Swiper !== 'function') return;

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el) continue;

      // If the theme web-component is used, let it handle init.
      if ((window.customElements && customElements.get('fuzion-swiper-slider')) && el.tagName === 'FUZION-SWIPER-SLIDER') continue;
      if (el.swiper) continue;

      var speedAttr = el.getAttribute('speed');
      var speedNum = speedAttr ? (parseInt(speedAttr, 10) || 0) : 0;

      var spvAttr = el.getAttribute('data-slidesperview');
      var slidesPerView = spvAttr ? (parseFloat(spvAttr) || 1) : 1;

      var autoplayAttr = el.getAttribute('autoplayslider');
      var autoplayEnabled = autoplayAttr === 'true' || autoplayAttr === '1';

      var navPagAttr = el.getAttribute('data-navigation_pagination');
      var navigationPagination = navPagAttr === 'true' || navPagAttr === '1';

      var section = el.closest && el.closest('[data-section-id]');
      var totalSlides = (el.querySelectorAll && el.querySelectorAll('.swiper-slide') || []).length;

      var scrollbarEl = el.querySelector('.swiper-scrollbar') || (section && section.querySelector('.swiper-scrollbar'));
      var nextEl = el.querySelector('.swiper-button-next') || (section && section.querySelector('.swiper-button-next'));
      var prevEl = el.querySelector('.swiper-button-prev') || (section && section.querySelector('.swiper-button-prev'));
      var pagEl = el.querySelector('.swiper-pagination') || (section && section.querySelector('.swiper-pagination'));

      var config = {
        slidesPerView: slidesPerView,
        spaceBetween: 30,
        freeMode: false,
        loop: false,
        speed: speedNum,
        allowTouchMove: true,
        autoplay: autoplayEnabled
          ? {
              delay: speedNum || 2000,
              disableOnInteraction: false
            }
          : false,
        scrollbar: scrollbarEl
          ? {
              el: scrollbarEl,
              draggable: true,
              dragSize: 87
            }
          : false,
        navigation: navigationPagination && nextEl && prevEl
          ? { nextEl: nextEl, prevEl: prevEl }
          : false,
        pagination: navigationPagination && pagEl
          ? {
              el: pagEl,
              clickable: true,
              renderBullet: function (index, className) {
                return (
                  '<div class="main-v-pag">' +
                  '<span class="' +
                  className +
                  '"></span>' +
                  '<div class="v-slide-name">' +
                  '<span class="slide-number">' +
                  (index + 1) +
                  '</span>' +
                  (totalSlides ? '<span class="total-slides">/' + totalSlides + '</span>' : '') +
                  '</div>' +
                  '</div>'
                );
              }
            }
          : false,
        breakpoints: {
          320: { slidesPerView: 2, spaceBetween: 15 },
          515: { slidesPerView: 2, spaceBetween: 15 },
          768: { slidesPerView: 3, spaceBetween: 15 },
          992: { slidesPerView: slidesPerView, spaceBetween: 20 },
          1299: { slidesPerView: slidesPerView, spaceBetween: 30 }
        }
      };

      try {
        var inst = new window.Swiper(el, config);
        if (typeof window.registerThemeSwiper === 'function') {
          window.registerThemeSwiper(el, inst);
        }
      } catch (err) {
        console.warn('initializeMuskPRODUCTSlider1: init error', err, el);
      }
    }
  }, function () {});
}

// Keep legacy behaviour: initialize on load + when sections are loaded in theme editor.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMuskPRODUCTSlider1);
} else {
  initializeMuskPRODUCTSlider1();
}
window.addEventListener('shopify:section:load', function () {
  initializeMuskPRODUCTSlider1();
});
